export default "__VITE_ASSET__CCYO9V_K__"